import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SendEmailRequest } from '@models/email/sendEmailRequest.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(
    private http: HttpClient
  ) { }

  send(sendEmailRequest: SendEmailRequest): Observable<any> {
    return this.http.post<any>('/api/Email/Send', sendEmailRequest)
  }
}
